import {Injectable} from '@angular/core';

@Injectable()
export class MapServiceInterface {

}



// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/widgets/map/map-service-interface.service.ts